module.exports = __webpack_public_path__ + "static/elf-ayagww-9dbe468544eead1ea75c518cbb38941f.png";